import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateCallFlow } from "../actions/update-config.actions";
import { UpdateCompanyCallFlowConfigPayload } from "../types/update-company-config";
import { callFlowQueryKeys } from "@components/virtual-receptionist/widget/components/ConfigureCallFlow/queries/call-flow.query";

export const useSettingsMutation = () => {
    const queryClient = useQueryClient()

    const update = useMutation({
        mutationFn: ({ companyId, payload }: { companyId: number, payload: UpdateCompanyCallFlowConfigPayload }) => {
            return updateCallFlow(companyId, payload)
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: callFlowQueryKeys.all })
        }
    })

    return { update }
}